 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		85: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		85: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"BusinessProtect360.Generate","23":"CILeadForm","24":"CIP.FactFormApp","25":"CIProtect360.Dashboard","26":"CIProtect360.Details","27":"CIProtect360.Direct.Generate","28":"CIProtect360.Generate","29":"CampaignLeadForm","30":"CarProtect360","31":"CashCardShield","32":"ChoicesProtect360","33":"CommissionStatement","34":"Common.Error","35":"Common.MyInfoCallback","36":"ComplimentaryHomeContents","37":"ConsumerPortal","38":"ContactUs","39":"CorporateTravel","40":"Debug","41":"EMAPortal","42":"EarlyProtect360Plus","43":"EarlyProtect360Plus.Dashboard","44":"EarlyProtect360Plus.Details","45":"FamilyProtect360","46":"FilipinoBond","47":"FlashPayShieldWithUpgrade","48":"FraudProtect360","49":"HIProtect360Protect360","50":"HomeProtect360","51":"HomeProtectLite","52":"HomeSafe","53":"HomeStarterKit","54":"InternalDemoCookie","55":"KeymanProtect360","56":"KeymanProtect360.Dashboard","57":"KeymanProtect360.Details","58":"LeadForm","59":"Loan Protect 360 Renewal","60":"LoanProtect360","61":"LoanProtect360.Dashboard","62":"LoanProtect360.Details","63":"MaidProtect360","64":"MotoringCardShieldWithUpgrade","65":"Motorshow2020","66":"PartnerProgram","67":"PhoneProtect360","68":"PowerAgentPortal","69":"Prestige","70":"Prestige.Secured","71":"PublicHousingAssured","72":"ReviewUs","73":"SOA","74":"SingaporeTravelPass","75":"Touristcard","76":"TravelAssured","77":"TravelAssuredPlus","78":"TravelProtect360","79":"TravelProtect360Plus","80":"cileadform","81":"currencyconverter","82":"freehomeinsurance","84":"motorshow","86":"transferprotect360pro","87":"vCashCard","88":"weather"}[chunkId]||chunkId) + "." + {"0":"f354b176","1":"b9234db1","2":"7afcd218","3":"d6568ae8","4":"da639cb8","5":"4cd39146","6":"5ec86d4a","7":"50346290","8":"cac29746","9":"d6e04b73","10":"3532cb52","11":"80c448be","12":"28a9f9a9","13":"dbc4ac7a","14":"4da05faa","15":"d3047913","16":"2c16a47d","17":"9d54a589","18":"48f02125","19":"b5345a2c","20":"b1b09389","21":"84ecde05","22":"e769ba62","23":"a21b4c23","24":"4eed444c","25":"6b2cf441","26":"dafd4e75","27":"0babcfbf","28":"a2d59b98","29":"5f8767f5","30":"c8fcd54e","31":"9ccf97af","32":"7b6551d2","33":"80004a96","34":"95312e69","35":"3f7e2e0b","36":"dff8d3fb","37":"9cd532a5","38":"42aac936","39":"e8466f6a","40":"c5ab990a","41":"15eac56e","42":"167dd46f","43":"4c6eccae","44":"e6759e2c","45":"33b9f046","46":"cd22c593","47":"307974b0","48":"cd063cd2","49":"b5549438","50":"ae5149d9","51":"566f4d0f","52":"763592e8","53":"64f0724c","54":"35f276bc","55":"133eebd2","56":"64ce3a19","57":"981c44dd","58":"735c591a","59":"7ec5fe9d","60":"f57afdf0","61":"9d83b2f3","62":"1f3aca56","63":"dfc60def","64":"0cc5fbef","65":"356cc11b","66":"737a92a6","67":"18bb8015","68":"4688a2f8","69":"a2b5cdbe","70":"f6f5390e","71":"d147f924","72":"9fe40f8c","73":"bc07c2b4","74":"a5035217","75":"b153a563","76":"c389a11e","77":"84105d96","78":"ce636d72","79":"0cf46d7f","80":"fb40243f","81":"245bb393","82":"98dbbb50","84":"70f321d1","86":"06e2a8c6","87":"8dcf048f","88":"cd8eeb77","90":"3294b76d","91":"17fbad93","92":"6a3b4376","93":"e9f1c219","94":"1991287c","95":"f6ed0bbb","96":"4efb0798","97":"f01667cd","98":"a62ea0f4","99":"015e1d2c","100":"130df093","101":"fce4cce2","102":"d785a316","103":"dc59b73f","104":"9adc1b67","105":"5ee0aaf6","106":"6a8094d6","107":"0343f5cc","108":"bf29c0e2","109":"c9a3968d","110":"d2e2b975","111":"749ce465","112":"04ece84a","113":"8fd8a3b4","114":"5259afa9","115":"19e28529","116":"e740c3be","117":"a412606c","118":"223ab11d","119":"af8635b8","120":"4fb39aaa","121":"70205a98","122":"5510b535","123":"796f2d7e","124":"8205af67","125":"3ab9dee2","126":"c81ba77a","127":"e08fe77e","128":"9ce83568","129":"5be071ef","130":"0c15fd97","131":"d131cfad","132":"0521e708","133":"61a2a364","134":"373bf5ab","135":"ce48da8e","136":"d7b9e675","137":"52d31ba3","138":"d31b4fd8","139":"d94d6451","140":"7e82f4dc","141":"03ddd27d","142":"08d84207","143":"875eaf8e","144":"92a0b229","145":"c15bf66d","146":"8d0154c5","147":"85371511","148":"5f1bd130","149":"f4f5f177","150":"ac51af4f","151":"7c0b45d1","152":"0567715f","153":"c5024d50","154":"33a444d0","155":"68dbc57d","156":"204ed596","157":"2e72628a","158":"f3b7c47d","159":"d9fa93f5","160":"314b9fa4","161":"5b681fc3","162":"15178ec9","163":"23c70fa2","164":"74cc9ecd","165":"0ac87516","166":"a49c0f8c","167":"d3becfbe","168":"64b107ea","169":"0742bc54","170":"da9719a4","171":"97fba9ea"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"19":1,"21":1,"22":1,"24":1,"27":1,"29":1,"30":1,"31":1,"32":1,"33":1,"36":1,"37":1,"39":1,"40":1,"42":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"55":1,"58":1,"63":1,"64":1,"66":1,"67":1,"68":1,"69":1,"70":1,"71":1,"73":1,"74":1,"75":1,"76":1,"77":1,"78":1,"79":1,"80":1,"81":1,"82":1,"84":1,"86":1,"87":1,"88":1,"91":1,"92":1,"94":1,"95":1,"96":1,"97":1,"98":1,"99":1,"100":1,"101":1,"102":1,"103":1,"109":1,"110":1,"117":1,"119":1,"122":1,"123":1,"126":1,"127":1,"128":1,"129":1,"130":1,"131":1,"132":1,"133":1,"134":1,"135":1,"136":1,"137":1,"138":1,"139":1,"151":1,"152":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"BusinessProtect360.Generate","23":"CILeadForm","24":"CIP.FactFormApp","25":"CIProtect360.Dashboard","26":"CIProtect360.Details","27":"CIProtect360.Direct.Generate","28":"CIProtect360.Generate","29":"CampaignLeadForm","30":"CarProtect360","31":"CashCardShield","32":"ChoicesProtect360","33":"CommissionStatement","34":"Common.Error","35":"Common.MyInfoCallback","36":"ComplimentaryHomeContents","37":"ConsumerPortal","38":"ContactUs","39":"CorporateTravel","40":"Debug","41":"EMAPortal","42":"EarlyProtect360Plus","43":"EarlyProtect360Plus.Dashboard","44":"EarlyProtect360Plus.Details","45":"FamilyProtect360","46":"FilipinoBond","47":"FlashPayShieldWithUpgrade","48":"FraudProtect360","49":"HIProtect360Protect360","50":"HomeProtect360","51":"HomeProtectLite","52":"HomeSafe","53":"HomeStarterKit","54":"InternalDemoCookie","55":"KeymanProtect360","56":"KeymanProtect360.Dashboard","57":"KeymanProtect360.Details","58":"LeadForm","59":"Loan Protect 360 Renewal","60":"LoanProtect360","61":"LoanProtect360.Dashboard","62":"LoanProtect360.Details","63":"MaidProtect360","64":"MotoringCardShieldWithUpgrade","65":"Motorshow2020","66":"PartnerProgram","67":"PhoneProtect360","68":"PowerAgentPortal","69":"Prestige","70":"Prestige.Secured","71":"PublicHousingAssured","72":"ReviewUs","73":"SOA","74":"SingaporeTravelPass","75":"Touristcard","76":"TravelAssured","77":"TravelAssuredPlus","78":"TravelProtect360","79":"TravelProtect360Plus","80":"cileadform","81":"currencyconverter","82":"freehomeinsurance","84":"motorshow","86":"transferprotect360pro","87":"vCashCard","88":"weather"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"a858c2f5","20":"31d6cfe0","21":"a858c2f5","22":"d30bc41f","23":"31d6cfe0","24":"d33f62d9","25":"31d6cfe0","26":"31d6cfe0","27":"58058363","28":"31d6cfe0","29":"05f863ac","30":"ddf1f108","31":"04bc7233","32":"ddf1f108","33":"d33f62d9","34":"31d6cfe0","35":"31d6cfe0","36":"0e4fba13","37":"978e5247","38":"31d6cfe0","39":"ac3f861f","40":"5d27deaa","41":"31d6cfe0","42":"58058363","43":"31d6cfe0","44":"31d6cfe0","45":"ddf1f108","46":"ddf1f108","47":"0e4fba13","48":"ddf1f108","49":"ddf1f108","50":"471a3a57","51":"471a3a57","52":"471a3a57","53":"0e4fba13","54":"31d6cfe0","55":"58058363","56":"31d6cfe0","57":"31d6cfe0","58":"dd9a60e3","59":"31d6cfe0","60":"31d6cfe0","61":"31d6cfe0","62":"31d6cfe0","63":"14284125","64":"0e4fba13","65":"31d6cfe0","66":"8b647349","67":"471a3a57","68":"716aad65","69":"2fc531d7","70":"cdec5a50","71":"471a3a57","72":"31d6cfe0","73":"d33f62d9","74":"2e8fdc12","75":"7986da5d","76":"86c9f98d","77":"86c9f98d","78":"2e8fdc12","79":"86c9f98d","80":"22b92479","81":"7b4f34de","82":"0e4fba13","84":"49234f01","86":"14284125","87":"94b03ce8","88":"23255cb6","90":"31d6cfe0","91":"cce35a68","92":"440606be","93":"31d6cfe0","94":"2d576837","95":"de3d9b53","96":"8b4bb37c","97":"f93319e8","98":"72c6f688","99":"f93319e8","100":"f93319e8","101":"72c6f688","102":"72c6f688","103":"de0b9e9d","104":"31d6cfe0","105":"31d6cfe0","106":"31d6cfe0","107":"31d6cfe0","108":"31d6cfe0","109":"6f6df1fe","110":"6f6df1fe","111":"31d6cfe0","112":"31d6cfe0","113":"31d6cfe0","114":"31d6cfe0","115":"31d6cfe0","116":"31d6cfe0","117":"6f6df1fe","118":"31d6cfe0","119":"6f6df1fe","120":"31d6cfe0","121":"31d6cfe0","122":"4b48318c","123":"4b48318c","124":"31d6cfe0","125":"31d6cfe0","126":"4b48318c","127":"4b48318c","128":"4b48318c","129":"4b48318c","130":"4b48318c","131":"4b48318c","132":"4b48318c","133":"4b48318c","134":"4b48318c","135":"4b48318c","136":"4b48318c","137":"4b48318c","138":"4b48318c","139":"4b48318c","140":"31d6cfe0","141":"31d6cfe0","142":"31d6cfe0","143":"31d6cfe0","144":"31d6cfe0","145":"31d6cfe0","146":"31d6cfe0","147":"31d6cfe0","148":"31d6cfe0","149":"31d6cfe0","150":"31d6cfe0","151":"5fe6802c","152":"5fe6802c","153":"31d6cfe0","154":"31d6cfe0","155":"31d6cfe0","156":"31d6cfe0","157":"31d6cfe0","158":"31d6cfe0","159":"31d6cfe0","160":"31d6cfe0","161":"31d6cfe0","162":"31d6cfe0","163":"31d6cfe0","164":"31d6cfe0","165":"31d6cfe0","166":"31d6cfe0","167":"31d6cfe0","168":"31d6cfe0","169":"31d6cfe0","170":"31d6cfe0","171":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.hlas.com.sg/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonphlas-react-app"] = this["webpackJsonphlas-react-app"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
